import { render } from "./MButtonIcon.vue?vue&type=template&id=c740b302&scoped=true"
import script from "./MButtonIcon.vue?vue&type=script&lang=js"
export * from "./MButtonIcon.vue?vue&type=script&lang=js"

import "./MButtonIcon.vue?vue&type=style&index=0&id=c740b302&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c740b302"]])

export default __exports__